import CookieNameSpace from '~/const/cookie';
import RouterNameSpace, { shouldSkipRoleHomePageRedirect } from '~/const/router';
import { getTokenFromStorage } from '~/helpers/storage';
import { useProfileStore } from '~/store/profile.store';

export default defineNuxtRouteMiddleware(async (to, from) => {
	if (to.meta.auth === false) return;
	const userStore = useProfileStore();
	const token = await getTokenFromStorage(CookieNameSpace.getAccessToken);
	if (!userStore.profileInfo) {
		if (token) {
			await userStore.getProfile(true);
		} else {
			await userStore.restoreCachedProfile();
		}
	}

	const tokenAfterProfileLoad = token ? await getTokenFromStorage(CookieNameSpace.getAccessToken) : null;
	const isProfilePending = !!tokenAfterProfileLoad && !userStore.profileInfo;
	const isNotLoggedIn = !isProfilePending && (!userStore.isLoggedIn || !userStore.profileInfo);
	const roleHomePages = ['/cargos', '/storekeeper', '/trucker'];
	const currentPath = to.path.replace(/\/+$/, '') || '/';
	const isRoleHomePage = roleHomePages.some(
		(path) => currentPath === path || currentPath.startsWith(`${path}/`) || currentPath.endsWith(path)
	);
	const shouldSkipRedirect = shouldSkipRoleHomePageRedirect(
		userStore.profileSettings?.role,
		currentPath
	);
	const isInitialNavigation = from.matched.length === 0;

	if (
		userStore.profileSettings?.defaultUrl &&
		(isRoleHomePage || currentPath === '/') &&
		!shouldSkipRedirect &&
		isInitialNavigation &&
		currentPath !== userStore.profileSettings.defaultUrl
	) {
		return navigateTo(userStore.profileSettings.defaultUrl, { replace: true });
	}

	switch (true) {
		case isNotLoggedIn && !to.path.includes('/authorization'): {
			if (from.path === RouterNameSpace.routerRedirectNoLoggedIn) return abortNavigation();
			return navigateTo(RouterNameSpace.routerRedirectNoLoggedIn, { replace: true });
		}
		case userStore.isLoggedIn && to.path.includes('/authorization'): {
			return navigateTo({
				path: userStore.profileSettings?.defaultUrl || RouterNameSpace.routerRedirectIsLoggedIn,
				replace: true
			});
		}
		default:
			break;
	}
});
